export const constantClasses = {
    sectionModule: ['wf-relative', 'wf-h-full'],
    rowModule: ['wf-flex', 'wf-flex-wrap', 'wf-flex-row', 'wf-w-full'],
    columnModule: [],
    componentColumnModule: [],
    componentSectionModule: ['wf-relative'],
}